.selector {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.section {
    display: flex;
    flex-direction: column;
}

.dropzone {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 30px;
	border: 3px dashed var(--hps-gray);
}

.dropzone p {
	margin: 0;
}

.dropzoneDragActive {
	background-color: var(--hps-light-gray);
}
